import { render } from "./programs-list.vue?vue&type=template&id=79645293"
import script from "./programs-list.vue?vue&type=script&lang=js"
export * from "./programs-list.vue?vue&type=script&lang=js"

import "./programs-list.vue?vue&type=style&index=0&id=79645293&lang=scss"
script.render = render

export default script